import { Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface AnswerButtonsProps {
  label: string;
  hint: string;
  value: boolean | null;
  onChange: (next: boolean | null) => void;
  disabled?: boolean;
}

export function AnswerButtons({ label, hint, value, onChange, disabled }: AnswerButtonsProps) {
  const choose = (answer: boolean) => onChange(value === answer ? null : answer);

  return (
    <div className="flex items-center gap-2" role="group" aria-label={label}>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              aria-label={`About: ${label}`}
              className="text-muted-foreground hover:text-foreground"
            >
              <Info className="h-4 w-4" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="top" className="max-w-xs">
            {hint}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <span className="flex-1 text-sm">{label}</span>
      <Button
        type="button"
        size="sm"
        variant={value === true ? "default" : "outline"}
        aria-pressed={value === true}
        disabled={disabled}
        onClick={() => choose(true)}
      >
        Yes
      </Button>
      <Button
        type="button"
        size="sm"
        variant={value === false ? "destructive" : "outline"}
        aria-pressed={value === false}
        disabled={disabled}
        onClick={() => choose(false)}
      >
        No
      </Button>
    </div>
  );
}
